import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c49b3968"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]

import { ADV_IMAGE, ADV_LINK } from '@/helpers/globalVars'


export default /*#__PURE__*/_defineComponent({
  __name: 'AD',
  setup(__props) {

const clickLink = () => {
  window.open(ADV_LINK, '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("img", {
    onClick: clickLink,
    class: "wrapper",
    src: `/img/${_unref(ADV_IMAGE)}`,
    alt: _unref(ADV_IMAGE)
  }, null, 8, _hoisted_1))
}
}

})